import Helpers from '@intelingu/core/helpers/Helpers';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';

interface FormattedStringProps {
    value: string;
    className?: string;
}

@observer export class FormattedString extends Component<FormattedStringProps, any> {

    elm: HTMLDivElement;

    componentDidMount(): void {
        Array.from(this.elm.getElementsByClassName('triangle-audio')).forEach(elm => {
            const audio = (elm.getElementsByTagName('audio')[0] as HTMLAudioElement);

            elm.addEventListener('click', () => {
                if (elm.classList.contains('is-playing')) {
                    elm.classList.remove('is-playing');
                    audio.pause();
                } else {
                    elm.classList.add('is-playing');
                    audio.currentTime = 0;
                    audio.play();
                }
            });

            audio.onended = () => {
                elm.classList.remove('is-playing');
            }
        });
    }

    get value() {
        return Helpers.replaceAudioComponents(this.props.value);
    }

    render() {
        return <div className={this.props.className} ref={elm => this.elm = elm} dangerouslySetInnerHTML={{ __html: this.value }} />
    }

}
